import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { observer } from 'mobx-react';
import userStore from '../../Stores/User';
import store from './store';
import SideBar from './Components/SideBar';
import Articles from './Components/Articles';
import PlaylistArticles from './Components/PlaylistArticles';
import Similar from './Components/Similar';
import Player, { PlayerWrapper } from '../../Components/PlayerNew';
import TopBar from './Components/TopBar';
import MobileHeader from './Components/MobileHeader';
import MobileMenu from './Components/MobileMenu';
import MobileContent from './Components/MobileContent';
import AddArticle from './Components/AddArticle';
import mixpanel from 'mixpanel-browser';
// import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useMediaQuery } from '@mui/material';
import './index.scss';
import '../common.scss';
import './CSS/Home.css';
import SubscribedFeeds from "./Components/SubscribedFeeds";

const DiscoverDesktop = observer(() => {
  const {
    isPlaying,
    loading,
    mode,
    changePlaylistMode,
    mobileMode,
    changeMode,
    loadPlaylist,
    popularArticles,
    searchArticles,
    similarArticles,
    playlistArticlesToShow,
    addArticleToPlaylist,
    changeCurrentArticleForcePlay,
    updateAddUrl,
    addUrl,
    selectionText,
    addApp,
    addForce,
    pendingSearch,
    updatePendingSearch,
    search,
    updateSearch,
    updateMobileSettingsActive,
    daysAgo,
    daysAgoOptions,
    updateDaysAgo,
    currentArticle,
    onPreviousArticle,
    onNextArticle,
    onArticleEnded,
    isFullPlayer,
    updateIsFullPlayer,
    togglePlayed,
    removeArticle,
    updateMounted,
  } = store;

  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const { user, userFeedUrl, triggers, trackingId, logOut } = userStore;
  const playingArticleId =
    isPlaying && currentArticle ? currentArticle.article_id : null;

  const [lastActivityTime, setLastActivityTime] = useState(Date.now());
  const [currentInterval, setCurrentInterval] = useState(5000); // Start with 5 seconds
  const INACTIVE_THRESHOLD = 5 * 60 * 1000; // 5 minutes in milliseconds
  const MAX_INTERVAL = 5 * 60 * 1000; // Max interval of 5 minutes

  // Track user activity
  useEffect(() => {
    const updateActivity = () => {
      setLastActivityTime(Date.now());
      setCurrentInterval(5000); // Reset to 5 seconds when user is active
    };

    // Track various user interactions
    window.addEventListener('mousemove', updateActivity);
    window.addEventListener('keydown', updateActivity);
    window.addEventListener('click', updateActivity);
    window.addEventListener('scroll', updateActivity);
    window.addEventListener('touchstart', updateActivity);

    return () => {
      window.removeEventListener('mousemove', updateActivity);
      window.removeEventListener('keydown', updateActivity);
      window.removeEventListener('click', updateActivity);
      window.removeEventListener('scroll', updateActivity);
      window.removeEventListener('touchstart', updateActivity);
    };
  }, []);

  useEffect(() => {
    // Only set playlist mode on initial load if we're starting in discover mode
    if (mode === "discover" && !mobileMode) {
      changeMode("playlist");
    }
    loadPlaylist();

    // Handle initial URL
    const pathname = window.location.pathname;
    if (pathname === "/add") {
      changeMode("addArticle");
      
      // Check if this is a redirect from successful Stripe setup
      const setupIntentId = localStorage.getItem("lastSetupIntentId");
      if (setupIntentId) {
        // Track successful trial start
        mixpanel.track("Premium trial started", {
          setup_intent_id: setupIntentId
        });
        // Clear the setup intent ID
        localStorage.removeItem("lastSetupIntentId");
      }
    } else if (pathname === "/") {
      changeMode("discover");
    }

    const checkInactivity = () => {
      const inactiveTime = Date.now() - lastActivityTime;
      if (inactiveTime > INACTIVE_THRESHOLD) {
        // Increase interval by 3x up to MAX_INTERVAL
        const newInterval = Math.min(currentInterval * 5, MAX_INTERVAL);
        setCurrentInterval(newInterval);
      }
    };

    const intervalId = setInterval(() => {
      try {
        loadPlaylist();
        checkInactivity(); // Check and adjust interval after each load
      } catch (error) {
        console.error("Error in playlist interval:", error);
      }
    }, currentInterval);

    return () => {
      clearInterval(intervalId);
    };
  }, [loadPlaylist, currentInterval, lastActivityTime]); // Add dependencies

  useEffect(() => {
    mixpanel.track('Open Discover');
    mixpanel.stop_session_recording();
  }, [mode, mobileMode]);
  // useEffect(() => {
  //   let newDaysAgo = 7;

  //   const currentDateTime = new Date();
  //   const lastVisitFromCookie = Cookies.get("audiblogsLastVisit");

  //   Cookies.set("audiblogsLastVisit", currentDateTime);

  //   if (lastVisitFromCookie) {
  //     const lastVisitDateTime = new Date(lastVisitFromCookie);

  //     newDaysAgo = Math.ceil(
  //       (currentDateTime - lastVisitDateTime) / 60000 / 60 / 24
  //     );
  //   }

  //   if (daysAgoOptions.length > 0) {
  //     newDaysAgo = Math.min(
  //       newDaysAgo,
  //       daysAgoOptions[daysAgoOptions.length - 1]
  //     );
  //   }

  //   updateDaysAgo(Math.max(newDaysAgo, 1), true);
  // }, [updateDaysAgo, daysAgoOptions]);

  useEffect(() => {
    updateMounted(true);

    return () => {
      updateMounted(false);
    };
  }, [updateMounted]);

  return (
    <div className="discover-main">
      <PlayerWrapper showPlayer={!!currentArticle}>
        {isDesktop ? (
          <div className="discover-desktop">
            <div className="discover-sidebar" style={{ visibility: 'hidden' }} />
            <div
              className="discover-sidebar"
              style={{ position: 'fixed', top: 0, left: 0 }}
            >
              <SideBar
                {...{
                  logOut,
                  mode,
                  userFeedUrl,
                  changeMode,
                  triggers,
                  displayName: user ? user.email || user.displayName : '',
                }}
              />
            </div>
            <div
              className="discover-articles"
              style={{ display: mode !== 'discover' ? 'none' : 'block' }}
            >
              <TopBar
                {...{
                  mode,
                  changePlaylistMode,
                  pendingSearch,
                  updatePendingSearch,
                  search,
                  updateSearch,
                  daysAgo,
                  daysAgoOptions,
                  updateDaysAgo,
                }}
              />
              <div></div>
              <div>
                <SubscribedFeeds />
              </div>
            </div>
            <div
              className="discover-articles"
              style={{
                display:
                  mode === 'discover' || mode === 'addArticle' ? 'none' : 'block',
              }}
            >
              <TopBar
                {...{
                  mode,
                  changePlaylistMode,
                  pendingSearch,
                  updatePendingSearch,
                  search,
                  updateSearch,
                  daysAgo,
                  daysAgoOptions,
                  updateDaysAgo,
                }}
              />
              <div style={{ height: "10px" }}></div>
              <PlaylistArticles
                {...{
                  articles: playlistArticlesToShow,
                  changePlaylistMode,
                  trackingId,
                  addArticleToPlaylist: null,
                  selectArticle: changeCurrentArticleForcePlay,
                  togglePlayed,
                  removeArticle,
                }}
              />
            </div>
            <div
              className="discover-articles"
              style={{ display: mode === 'addArticle' ? 'block' : 'none' }}
            >
              <div className="article-search">
                <div className="header">Add Article</div>
              </div>
              <div className="article-container" style={{
                marginTop: '-50px',
                marginRight: '250px',
              }}>
                <AddArticle
                  {...{
                    triggers,
                    trackingId,
                    selectionText,
                    updateAddUrl,
                    addUrl,
                    addApp,
                    addForce,
                  }}
                />
              </div>
            </div>
            <div className="discover-similar" style={{ display: 'none' }} />
            <div
              className="discover-similar"
              style={{ display: 'none' }}
            >
              <Similar
                {...{
                  articles: similarArticles,
                  trackingId,
                  addArticleToPlaylist,
                  selectArticle: changeCurrentArticleForcePlay,
                }}
              />
            </div>
          </div>
        ) : (
          <div className="discover-mobile">
            <div className="discover-mobile-header">
              <MobileHeader {...{ mobileMode, search }} />
            </div>
            <div className="discover-mobile-content">
              <MobileContent
                {...{
                  triggers,
                  userFeedUrl,
                  trackingId,
                  displayName: user ? user.email || user.displayName : '',
                  logOut,
                  mobileMode,
                  updateAddUrl,
                  addUrl,
                  addApp,
                  addForce,
                  selectionText,
                  pendingSearch,
                  updatePendingSearch,
                  search,
                  updateSearch,
                  daysAgo,
                  daysAgoOptions,
                  updateDaysAgo,
                  changePlaylistMode,
                }}
              />
            </div>
            <div
              className="discover-mobile-articles"
              style={{ display: mobileMode !== 'discover' ? 'none' : 'block' }}
            >
              <div></div>
              <div style={{ marginTop: "10px" }}>
                <SubscribedFeeds />
              </div>
            </div>
            <div
              className="discover-mobile-articles"
              style={{ display: mobileMode !== 'playlist' ? 'none' : 'flex' }}
            >
              <PlaylistArticles
                {...{
                  articles: playlistArticlesToShow,
                  changePlaylistMode,
                  trackingId,
                  addArticleToPlaylist: null,
                  selectArticle: changeCurrentArticleForcePlay,
                  togglePlayed,
                  removeArticle,
                }}
              />
            </div>
            <div className="discover-mobile-menu">
              <MobileMenu
                {...{
                  mode,
                  trackingId,
                  mobileMode,
                  changeMode,
                  updateMobileSettingsActive,
                  updateIsFullPlayer,
                }}
              />
            </div>
          </div>
        )}
      </PlayerWrapper>
      <div className="discover-player" style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: isFullPlayer ? 9999 : 1000,
        height: isFullPlayer ? '100vh' : 'auto',
        marginBottom: isFullPlayer ? 0 : '80px'
      }}>
        <Player
          {...{
            isFullPlayer,
            updateIsFullPlayer,
            currentArticle,
            onPreviousArticle,
            onNextArticle,
            onArticleEnded,
            listeningWhere: '/discover',
            autoPlay: false,
            fullPlayerLeaveSpace: 0,
          }}
        />
      </div>
    </div>
  );
});

export default DiscoverDesktop;
